<template>
  <div class="top_menu">
    <div class="menu_logo">
      <div class="menu_img" :style="imgBoxStyle">
        <img src="@/assets/img/logo.png" alt="" srcset="" :style="imgStyle" />
      </div>
      <div class="fade_name" :style="{ width: zdWidth }">
        <transition name="fade">
          <p v-show="show">{{ $t("lang.智电生态") }}</p>
        </transition>
      </div>
    </div>
    <div class="top_menu_right">
      <!-- header 最左侧 -->
      <div class="right_icon" @click="toggleMenu">
        <i
          class="iconfont icon-hanbaobao"
          style="color: #fff; cursor: pointer; font-size: 0.10417rem"
        ></i>
      </div>
      <div class="menu_right_list">
        <!-- 下载 -->
        <div class="right_icon curpointer" @click="showDownLoad">
          <el-popover
            placement="bottom"
            trigger="hover"
            popper-class="topmenubar_popover_width"
          >
            <i
              slot="reference"
              style="font-size: 0.11458rem; color: #fff"
              class="icon-xiazai iconfont"
            ></i>
            <div class="icon_name">{{ $t("lang.导出记录") }}</div>
          </el-popover>
        </div>
        <!-- app下载显示 -->
        <div class="right_icon curpointer">
          <el-popover
            placement="bottom"
            width="180"
            trigger="hover"
            popper-class="appdownbox_popover_width"
          >
            <i
              slot="reference"
              style="color: #fff; font-size: 0.11458rem"
              class="icon-download iconfont"
            ></i>
            <div class="qrcode-container">
              <div class="qrcode-item">
                <p class="platform-label">{{ $t("lang.安卓版下载") }}</p>
                <img
                  src="@/assets/img/qrcode/android.png"
                  alt="Android Download"
                  class="qrcode-image"
                />
                <p class="platform-hint">{{ $t("lang.扫描下载安卓版") }}</p>
              </div>
              <div class="qrcode-item">
                <p class="platform-label">{{ $t("lang.iOS版下载") }}</p>
                <img
                  src="@/assets/img/qrcode/ios.png"
                  alt="iOS Download"
                  class="qrcode-image"
                />
                <p class="platform-hint">{{ $t("lang.扫描下载iOS版") }}</p>
              </div>
            </div>
          </el-popover>
        </div>
        <!-- 消息记录 -->
        <div class="right_icon curpointer" @click="openMessageRecordPanel">
          <el-popover
            placement="bottom"
            trigger="hover"
            popper-class="topmenubar_popover_width"
          >
            <i
              slot="reference"
              style="font-size: 0.11458rem; color: #fff"
              class="icon-news iconfont"
            ></i>
            <div class="icon_name">{{ $t("lang.消息记录") }}</div>
          </el-popover>
        </div>
        <!-- 语言切换 -->
        <el-dropdown class="right_icon curpointer" @command="toggleLanguage">
          <div class="right_icon">
            <i
              style="font-size: 0.130208rem; color: #fff"
              class="icon-switch iconfont"
            ></i>
          </div>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="0">简体中文</el-dropdown-item>
            <el-dropdown-item command="1">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 头像 -->
        <el-dropdown class="menu_dropdown curpointer" @command="logout">
          <div class="head_portrait">
            <p>{{ username }}</p>
            <el-avatar
              style="pointer-events: none"
              size="medium"
              src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
            ></el-avatar>
            <i class="el-icon-caret-bottom el-icon--right"></i>
          </div>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="0">
              {{ $t("lang.个人中心") }}
            </el-dropdown-item>
            <el-dropdown-item command="1">
              {{ $t("lang.价格管理") }}
            </el-dropdown-item>
            <el-dropdown-item command="2">
              {{ $t("lang.币种设置") }}
            </el-dropdown-item>
            <el-dropdown-item command="3">
              {{ $t("lang.退出登录") }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <AnnouncementDialog />
    <CurrencyDialog ref="currencyRef" />
  </div>
</template>

<script>
import AnnouncementDialog from "./announcement-dialog.vue";
import CurrencyDialog from "./currency-dialog.vue";
export default {
  inject: ["reload"],
  components: { AnnouncementDialog, CurrencyDialog },
  props: {
    isCollapse: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      show: false,
      zdWidth: "0px",
      timer: null,
      imgBoxStyle: { width: 25 / 192 + "rem", height: 25 / 192 + "rem" },
      imgStyle: { width: 25 / 192 + "rem", height: 25 / 192 + "rem" },
      url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      username: "",
    };
  },
  created() {
    this.username = JSON.parse(sessionStorage.getItem("userInfo")).username;
  },
  mounted() {
    let that = this;
    this.$bus.$on("userNameModify", function (data) {
      let name = JSON.parse(sessionStorage.getItem("userInfo"));
      name.username = data;
      sessionStorage.setItem("userInfo", JSON.stringify(name));
      that.username = data;
    });
  },
  destroyed() {
    this.$bus.$off("userNameModify");
  },
  methods: {
    //点击打开和关闭左侧菜单
    toggleMenu() {
      this.zdWidth = this.zdWidth == "0px" ? 120 / 192 + "rem" : "0px";
      this.imgBoxStyle =
        this.zdWidth == "0px"
          ? { width: 25 / 192 + "rem", height: 25 / 192 + "rem" }
          : { width: 40 / 192 + "rem", height: 40 / 192 + "rem" };
      this.imgStyle =
        this.zdWidth == "0px"
          ? { width: 25 / 192 + "rem", height: 25 / 192 + "rem" }
          : { width: 40 / 192 + "rem", height: 40 / 192 + "rem" };
      clearTimeout(this.timer);
      if (this.zdWidth != "0px") {
        this.timer = setTimeout(() => {
          this.show = this.zdWidth != "0px";
        }, 200);
      } else {
        this.show = this.zdWidth != "0px";
      }

      this.$emit("toggleMenu", !this.isCollapse);
    },

    showDownLoad() {
      this.$store.commit("showDownload", true);
    },
    /**消息记录 */
    openMessageRecordPanel() {
      this.$router.push("/messageRecord");
    },
    // 中英文切换
    toggleLanguage(e) {
      this.$i18n.locale = e == 1 ? "en-US" : "zh-CN";
      localStorage.setItem("i18nlanguage", this.$i18n.locale);
      this.reload();
    },
    //账户头像下的菜单
    logout(e) {
      if (e == 0) {
        this.$router.push("/personalCenter");
      } else if (e == 1) {
        this.$router.push("/priceControl");
      } else if (e == 2) {
        this.$refs.currencyRef.showDialog();
      } else if (e == 3) {
        sessionStorage.removeItem("token");
        // this.$route.meta.keepAlive = false;
        this.$router.replace("/login");
      }
    },
  },
};
</script>

<style lang='less' scoped>
.qrcode-container {
  display: flex;
  justify-content: space-between;
  padding: 12px 10px;
  .qrcode-item {
    text-align: center;
    flex: 1;
    &:first-child {
      margin-right: 15px;
    }
    .platform-label {
      margin: 0 0 8px 0;
      font-size: 13px;
      font-weight: 500;
      color: #333;
      white-space: nowrap;
    }
    .qrcode-image {
      width: 90px;
      height: 90px;
      border: 1px solid #eee;
      border-radius: 6px;
      padding: 2px;
      background: #fff;
      box-sizing: border-box;
    }
    .platform-hint {
      margin: 6px 0 0 0;
      font-size: 11px;
      color: #666;
      white-space: nowrap;
    }
  }
}
.top_menu {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  background-color: #409eff;
  .top_menu_right {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .right_icon {
      width: 60px;
      height: 60px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
    .right_icon :hover {
      width: 60px;
      height: 60px;
      background-color: #0080ff;
      opacity: 0.8;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
    .menu_right_list {
      display: flex;
      align-items: center;
      margin-right: 10px;
      .menu_dropdown {
        padding: 0 10px;
        height: 60px;
      }
      .menu_dropdown :hover {
        padding: 0 10px;
        background-color: #0080ff;
        opacity: 0.6;
        height: 60px;
      }
      .head_portrait {
        display: flex;
        align-items: center;
        padding: 0 10px;
        height: 60px;
        p {
          pointer-events: none;
          color: #ffffff;
          font-size: 16px;
          margin-right: 10px;
        }
        i {
          pointer-events: none;
          color: #ffffff;
        }
      }
    }
  }
  .menu_logo {
    padding: 0 20px;
    display: flex;
    align-items: center;
    background-color: #65affb;
    height: 60px;
    .fade_name {
      width: 120px;
      transition: width 0.3s ease-in-out;
      p {
        font-size: 17px;
        color: #ffffff;
        font-weight: 500;
        margin-left: 10px;
      }
    }

    .menu_img {
      width: 25px;
      height: 25px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      border-radius: 20px;
      background-color: #c6dfff;
      transition: all 0.3s;
      img {
        width: 25px;
        height: 25px;
        transition: all 0.3s;
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.curpointer {
  cursor: pointer;
}
.app_down {
  min-width: 177px;
  padding: 0px 16px 8px 16px;
  border-bottom: 1px solid #e9e9e9;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
  margin-bottom: 5px;
}
.icon_name {
  font-size: 14px;
  color: #666;
  text-align: center;
}
.text1 {
  font-size: 12px;
  line-height: 14px;
  color: #409eff;
  text-align: center;
  padding: 5px 10px 0 10px;
}
</style>
<style>
.topmenubar_popover_width {
  min-width: 65px !important;
}
.appdownbox_popover_width {
  width: fit-content !important;
}
</style>